import React, { useState } from 'react';
import { update, loadError } from '../Actions/Cart.action';
import { reloadPayment } from '../Actions/Checkout.action';
import { debounce } from 'lodash-es';
import { useDispatch } from 'react-redux';
import { catchError } from '../Actions/Error.action';
import { translate } from '../Services/translation';

const CartProductQuantity = ({order}) =>  {
    const dispatch = useDispatch();
    const mapCartToAbort = {};
    const maxOrderQuantity = order.maxOrderQuantity;
    const [quantity, setQuantity] = useState(order.quantity);

    const checkValueOutOfFocus = (value) => {
        if (!value) {
            setQuantity(order.quantity)
        }
    }

    const onQuantityChange = debounce((newQuantity) => {
        const parsedQuantity = parseInt(newQuantity)
        if (isNaN(parsedQuantity)) {
            setQuantity(newQuantity);
            return;
        }
        if (maxOrderQuantity && parsedQuantity > maxOrderQuantity) {
            return;
        }
        if (parsedQuantity > 0) {
            setQuantity(parsedQuantity);
            mapCartToAbort[order.articleNumber] = new AbortController();
            dispatch(
                update(order.articleNumber, parsedQuantity, mapCartToAbort[order.articleNumber])
            ).then(() => {
                dispatch(reloadPayment());
            });
        }
    });

    return (
        <div className="cart-row__quantity-container">
            <button
                type="button"
                className="cart-row__quantity-button"
                onClick={event =>
                    onQuantityChange(quantity - 1)
                }
            >
            &minus;
            </button>
            {order.isFreeGift ? (
                <div> {order.quantity} </div>
            ) : (
                <input
                    className="cart-row__input"
                    type="number"
                    min="1"
                    maxLength={3}
                    value={quantity}
                    onChange={event =>
                        onQuantityChange(event.target.value)
                    }
                    onBlur={event => checkValueOutOfFocus(event.target.value)}
                    aria-label={translate('product.quantity')}
                />
            )}
            <button
                type="button"
                className="cart-row__quantity-button"
                onClick={event =>
                    onQuantityChange(quantity + 1)
                }
            >
            +
            </button>
        </div>
    )
}

export default CartProductQuantity;
